import "./IndustrialScaffolding.module.css";
import Header from "@/reusable_sections/Header";
import IndustrialScaffolding from "./sections/IndustrialScaffolding";
import RelatedServices from "./sections/RelatedServices";
import Footer from "@/reusable_sections/Footer";
export default function IndustrialScaffoldingPage() {
  return <div>
      <Header />
      <IndustrialScaffolding />
      <RelatedServices />
      <Footer />
    </div>;
}